/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useState } from "react";
import {
  Button,
  Menu,
  MenuItem,
  Popper,
  Paper,
  MenuList,
  Grow,
  ClickAwayListener,
  ListItemText,
} from "@mui/material";
import mergeTagsValue from "../../common/template-merge-tags.json";
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { ArrowDown01Icon, ArrowRight01Icon } from "@hugeicons-pro/core-stroke-rounded";

interface MergeTagsDropdownProps {
  insertAtCursor: (text: string) => void;
};

const MergeTagsDropdown: React.FC<MergeTagsDropdownProps> = ({ insertAtCursor }) => {
  const [mainAnchorEl, setMainAnchorEl] = useState<null | HTMLElement>(null);
  const [submenuAnchorEl, setSubmenuAnchorEl] = useState<null | HTMLElement>(null);
  const [hoveredMenu, setHoveredMenu] = useState<any>(null);

  const handleMainClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setMainAnchorEl(event.currentTarget);
  };

  const handleMainClose = (): void => {
    setMainAnchorEl(null);
    setHoveredMenu(null);
    setSubmenuAnchorEl(null);
  };

  const handleSubmenuClose = (): void => {
    setHoveredMenu(null);
    setSubmenuAnchorEl(null);
  };

  const isMainOpen = Boolean(mainAnchorEl);

  // Menu styles
  const menuPaperStyles = {
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)", // Reduced shadow
    backgroundColor: "#ffffff", // White background
  };

  return (
    <>
      <Button
        onClick={handleMainClick}
        endIcon={
          <HugeiconsIcon icon={ArrowDown01Icon} size={16} color="#3a3a3a" strokeWidth={0.2} />
        }
        sx={{
          height: "36px",
          textTransform: "none",
          fontFamily: "Manrope, sans-serif",
          color: "#3a3a3a",
          backgroundColor: "#ffffff", // White background
          border: "1px solid #e0e0e0",
          borderRadius: "20px", // Oval border for the main button
          paddingLeft: "16px",
          paddingRight: "12px",
          "&:hover": {
            backgroundColor: "#f9f9f9",
          },
          boxShadow: "none", // Remove any default button shadow
        }}
      >
        Merge Tags
      </Button>

      {/* Main Menu */}
      <Menu
        anchorEl={mainAnchorEl}
        open={isMainOpen}
        onClose={handleMainClose}
        PaperProps={{ 
          style: { 
            minWidth: 200,
            ...menuPaperStyles
          }
        }}
        MenuListProps={{
          onMouseLeave: () => {
            // only close submenu when not hovering over it
            setTimeout(() => {
              if (!submenuAnchorEl) {
                handleMainClose();
              }
            }, 200);
          },
          sx: { 
            padding: "6px 0", // Adjust padding to match the reference image
          }
        }}
      >
        {mergeTagsValue.map((item: any) =>
          item.menu ? (
            <MenuItem
              key={item.title}
              onMouseEnter={(e) => {
                // Close previous submenu when hovering a different menu item
                setHoveredMenu(item);
                setSubmenuAnchorEl(e.currentTarget);
              }}
              onClick={(e) => e.stopPropagation()}
              sx={{
                height: "36px", // Adjusted height to match reference image
                padding: "0 16px", 
                "&:hover": {
                  backgroundColor: "#f5f5f5"
                }
              }}
            >
              <ListItemText  
                primaryTypographyProps={{
                  sx: {
                    fontSize: "14px",
                    color: "#3a3a3a",
                    fontWeight: 400,
                  }
                }} 
              >
                {item.title}
              </ListItemText>
              <HugeiconsIcon icon={ArrowRight01Icon} size={16} color="#3a3a3a" strokeWidth={0.2} />
            </MenuItem>
          ) : (
            <MenuItem
              key={item.title}
              onClick={() => {
                insertAtCursor(`{{${item.value}}}`);
                handleMainClose();
              }}
              onMouseEnter={() => {
                // Close submenu when hovering a regular menu item
                setHoveredMenu(null);
                setSubmenuAnchorEl(null);
              }}
              sx={{
                height: "36px", // Adjusted height
                padding: "0 16px",
                "&:hover": {
                  backgroundColor: "#f5f5f5"
                }
              }}
            >
              <ListItemText  
                primaryTypographyProps={{
                  sx: {
                    fontSize: "14px",
                    color: "#3a3a3a",
                    fontWeight: 400
                  }
                }}
              >
                {item.title}
              </ListItemText>
            </MenuItem>
          )
        )}
      </Menu>

      {/* Submenu */}
      <Popper
        open={Boolean(hoveredMenu)}
        anchorEl={submenuAnchorEl}
        placement="right-start"
        disablePortal
        style={{ zIndex: 1302 }}
        modifiers={[
          {
            name: "offset",
            options: {
              offset: [20, 3], // Increased gap between main menu and submenu
            },
          },
        ]}
        transition
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper
              onMouseLeave={handleSubmenuClose}
              sx={{ 
                minWidth: 180,
                ...menuPaperStyles
              }}
            >
              <ClickAwayListener onClickAway={handleSubmenuClose}>
                <MenuList sx={{ padding: "6px 0" }}>
                  {hoveredMenu?.menu?.map((subItem: any) => (
                    <MenuItem
                      key={subItem.value}
                      onClick={() => {
                        insertAtCursor(`{{${subItem.value}}}`);
                        handleMainClose();
                      }}
                      sx={{
                        height: "36px", // Adjusted height to match reference
                        padding: "0 16px",
                        margin: "2px 0", // Adjusted spacing between items to better match reference
                        "&:hover": {
                          backgroundColor: "#f5f5f5"
                        }
                      }}
                    >
                      <ListItemText 
                        primaryTypographyProps={{
                          sx: {
                            fontSize: "14px",
                            color: "#3a3a3a",
                            fontWeight: 400
                          }
                        }}
                      >
                        {subItem.title}
                      </ListItemText>
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

export default MergeTagsDropdown;